// CANONICAL COPY (GH #7115). src/constants/obligations/obl-data-portability.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-data-portability',
  title: 'Verify data portability and transfer capability',
  description:
    'Confirm that the organization can, where required by law or contract, provide data to the party entitled to it in a structured, commonly used and machine-readable format, and transmit it to another recipient where technically feasible (GDPR Art. 20; CRA Annex I Part I §1.2(m) — the "transfer" half of the erase-or-transfer requirement). This is distinct from secure deletion: it is the technical export/handover capability. Review the data-export / portability procedure and evidence that requests can be fulfilled within the applicable deadline.',
  category: 'compliance',
  scfIds: ['SCF-DAT-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Data portability / export procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
